export default __webpack_public_path__ + "static/media/co-work.675e5e99.svg";